import { Link } from "react-router-dom";

import { PageHeader } from "@/components/PageHeader";
import { SEO } from "@/components/SEO";
import { fees, registrationForms } from "@/content/site";

export function JoinPage() {
  return (
    <>
      <SEO
        title="Join Our Club"
        description="Join Membertou Boxing Club. Registration fees, Boxing Canada forms, and everything you need to become a certified amateur boxer. Training is free."
        path="/join"
      />

      <PageHeader
        eyebrow="Membership"
        title="Join Our Club"
        intro="The Membertou Boxing Club encourages everyone to become certified amateur boxers. Below you will find the required registration information and forms."
      />

      <section className="section section-white texture-light" aria-labelledby="registration-heading">
        <div className="container-page max-w-3xl">
          <span className="eyebrow">Registration</span>
          <h2 id="registration-heading" className="mt-2">
            Boxing Nova Scotia &amp; Boxing Canada
          </h2>
          <p className="mt-4">
            Membertou Boxing follows Boxing Nova Scotia and Boxing Canada
            registration guidelines.
          </p>
          <ul className="mt-4 list-disc pl-5 space-y-2">
            <li>Please review the registration guidelines.</li>
            <li>Please complete the registration form.</li>
            <li>Training at Membertou Boxing Club is free.</li>
            <li>Registration fees are required by Boxing Nova Scotia.</li>
          </ul>
        </div>
      </section>

      <section className="section section-light texture-light" aria-labelledby="fees-heading">
        <div className="container-page">
          <span className="eyebrow">Fees</span>
          <h2 id="fees-heading" className="mt-2">
            Annual Registration Fees
          </h2>

          <div className="mt-8 overflow-x-auto">
            <table className="w-full text-left border-collapse bg-brand-white rounded-xl overflow-hidden border border-brand-border-light">
              <caption className="sr-only">
                Boxing Nova Scotia annual registration fees
              </caption>
              <thead style={{ backgroundColor: "#0a0a0a", color: "#fff" }}>
                <tr>
                  <th scope="col" className="px-4 py-3 text-sm uppercase tracking-wide font-sans font-semibold normal-case">
                    Category
                  </th>
                  <th scope="col" className="px-4 py-3 text-sm uppercase tracking-wide font-sans font-semibold normal-case">
                    Annual fee
                  </th>
                </tr>
              </thead>
              <tbody>
                {fees.map((row) => (
                  <tr
                    key={row.category}
                    className="border-t border-brand-border-light"
                  >
                    <th scope="row" className="px-4 py-4 align-top font-semibold">
                      {row.category}
                    </th>
                    <td className="px-4 py-4 align-top">{row.amount}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <p className="mt-6" style={{ maxWidth: "none" }}>
            <strong>Please note:</strong> these fees are required by Boxing Nova Scotia.
          </p>
          <p
            className="mt-4 text-lg font-semibold"
            style={{ color: "#d71920", maxWidth: "none" }}
          >
            Training at the Membertou Boxing Club is free.
          </p>
        </div>
      </section>

      <section className="section section-white texture-light" aria-labelledby="forms-heading">
        <div className="container-page">
          <span className="eyebrow">Forms</span>
          <h2 id="forms-heading" className="mt-2">
            Registration Forms
          </h2>

          <ul className="mt-10 grid gap-8 sm:grid-cols-2 list-none p-0">
            {registrationForms.map((form, i) => (
              <li key={form.title} className="h-full">
                <article
                  className="flex flex-col gap-4 h-full p-8 sm:p-10"
                  style={{
                    backgroundColor: i === 0 ? "#fff" : "#f5f5f5",
                    color: "#0a0a0a",
                    borderTop: "4px solid #d71920",
                    borderLeft: `2px solid rgba(10,10,10,${i === 0 ? "0.1" : "0.06"})`,
                    borderRight: `2px solid rgba(10,10,10,${i === 0 ? "0.1" : "0.06"})`,
                    borderBottom: `2px solid rgba(10,10,10,${i === 0 ? "0.1" : "0.06"})`,
                    borderRadius: "12px",
                    boxShadow: i === 0 ? "0 2px 12px rgba(0,0,0,0.08)" : "none",
                  }}
                >
                  <h3 className="text-2xl font-bold font-sans normal-case tracking-wide">{form.title}</h3>
                  <p className="text-base leading-relaxed" style={{ color: "#0a0a0a" }}>{form.label}</p>
                  <div className="mt-auto pt-4 flex flex-col gap-2">
                    {form.available ? (
                      <>
                        <a href={form.href} className={i === 0 ? "btn-primary" : "btn-outline"} target="_blank" rel="noreferrer noopener">
                          Download form<span className="sr-only"> ({form.title}, opens in a new tab)</span>
                        </a>
                        <p className="text-xs uppercase tracking-wide" style={{ color: "#888" }}>
                          {form.fileInfo}
                        </p>
                      </>
                    ) : (
                      <p className="text-sm" style={{ color: "#888" }}>
                        Contact the club for this form.
                      </p>
                    )}
                  </div>
                </article>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section
        className="relative overflow-hidden"
        style={{ backgroundColor: "#d71920", color: "#fff" }}
      >
        <div className="container-page relative z-10 py-16 sm:py-20 text-center flex flex-col items-center gap-5">
          <h2 className="max-w-[20ch]">Questions about joining?</h2>
          <p className="text-lg max-w-prose" style={{ color: "rgba(255,255,255,0.9)" }}>
            Reach out and we&apos;ll help you get started.
          </p>
          <div className="mt-2 flex flex-col sm:flex-row w-full sm:w-auto justify-center gap-3 sm:gap-4">
            <Link to="/contact" className="btn-on-red w-full sm:w-auto">
              Contact Us
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
